import React, { useState } from 'react';
import { 
  Search, 
  Plus, 
  Edit, 
  Trash2, 
  Eye, 
  User,
  Shield,
  Mail,
  Phone,
  Lock,
  UserCheck
} from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const Utilisateurs = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [roleFilter, setRoleFilter] = useState('Tous');
  const { hasPermission } = useAuth();

  const utilisateurs = [
    {
      id: 1,
      nom: 'Jean Dupont',
      email: 'jean.dupont@atl-marseille.fr',
      telephone: '+33 6 12 34 56 78',
      role: 'admin',
      statut: 'Actif',
      derniereConnexion: '2024-01-15 14:30',
      permissions: ['livraisons:read', 'livraisons:write', 'clients:read', 'clients:write', 'fournisseurs:read', 'fournisseurs:write', 'rapports:read', 'users:read', 'users:write']
    },
    {
      id: 2,
      nom: 'Marie Martin',
      email: 'marie.martin@atl-marseille.fr',
      telephone: '+33 6 98 76 54 32',
      role: 'manager',
      statut: 'Actif',
      derniereConnexion: '2024-01-15 13:45',
      permissions: ['livraisons:read', 'livraisons:write', 'clients:read', 'clients:write', 'fournisseurs:read', 'rapports:read']
    },
    {
      id: 3,
      nom: 'Pierre Durand',
      email: 'pierre.durand@atl-marseille.fr',
      telephone: '+33 6 11 22 33 44',
      role: 'operateur',
      statut: 'Actif',
      derniereConnexion: '2024-01-15 12:15',
      permissions: ['livraisons:read', 'livraisons:write', 'clients:read', 'fournisseurs:read']
    },
    {
      id: 4,
      nom: 'Sophie Bernard',
      email: 'sophie.bernard@atl-marseille.fr',
      telephone: '+33 6 55 66 77 88',
      role: 'operateur',
      statut: 'Inactif',
      derniereConnexion: '2024-01-10 16:20',
      permissions: ['livraisons:read', 'clients:read']
    }
  ];

  const roles = [
    { value: 'admin', label: 'Administrateur', color: 'bg-red-100 text-red-800' },
    { value: 'manager', label: 'Manager', color: 'bg-blue-100 text-blue-800' },
    { value: 'operateur', label: 'Opérateur', color: 'bg-green-100 text-green-800' }
  ];

  const getRoleInfo = (role) => {
    return roles.find(r => r.value === role) || { label: role, color: 'bg-gray-100 text-gray-800' };
  };

  const filteredUtilisateurs = utilisateurs.filter(utilisateur => {
    const matchesSearch = 
      utilisateur.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
      utilisateur.email.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesRole = roleFilter === 'Tous' || utilisateur.role === roleFilter;
    
    return matchesSearch && matchesRole;
  });

  if (!hasPermission('users:read')) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <Shield className="h-12 w-12 text-red-500 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-port-gray-900 mb-2">Accès refusé</h3>
          <p className="text-port-gray-600">Vous n'avez pas les permissions nécessaires pour accéder à cette page.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* En-tête */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-port-gray-900">Gestion des utilisateurs</h1>
          <p className="text-port-gray-600">Gestion des utilisateurs et des rôles ATL</p>
        </div>
        {hasPermission('users:write') && (
          <button className="btn-primary flex items-center space-x-2">
            <Plus className="h-5 w-5" />
            <span>Nouvel utilisateur</span>
          </button>
        )}
      </div>

      {/* Statistiques 
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="card p-6">
          <div className="flex items-center">
            <div className="p-3 rounded-lg bg-atl-blue-500">
              <User className="h-6 w-6 text-white" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-port-gray-600">Total utilisateurs</p>
              <p className="text-2xl font-bold text-port-gray-900">{utilisateurs.length}</p>
            </div>
          </div>
        </div>
        
        <div className="card p-6">
          <div className="flex items-center">
            <div className="p-3 rounded-lg bg-atl-green-500">
              <UserCheck className="h-6 w-6 text-white" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-port-gray-600">Utilisateurs actifs</p>
              <p className="text-2xl font-bold text-port-gray-900">
                {utilisateurs.filter(u => u.statut === 'Actif').length}
              </p>
            </div>
          </div>
        </div>
        
        <div className="card p-6">
          <div className="flex items-center">
            <div className="p-3 rounded-lg bg-yellow-500">
              <Shield className="h-6 w-6 text-white" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-port-gray-600">Administrateurs</p>
              <p className="text-2xl font-bold text-port-gray-900">
                {utilisateurs.filter(u => u.role === 'admin').length}
              </p>
            </div>
          </div>
        </div>
        
        <div className="card p-6">
          <div className="flex items-center">
            <div className="p-3 rounded-lg bg-port-gray-500">
              <User className="h-6 w-6 text-white" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-port-gray-600">Managers</p>
              <p className="text-2xl font-bold text-port-gray-900">
                {utilisateurs.filter(u => u.role === 'manager').length}
              </p>
            </div>
          </div>
        </div>
      </div>*/}

      {/* Filtres et recherche */}
      <div className="card p-6">
        <div className="flex flex-col md:flex-row gap-4">
          <div className="flex-1">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-port-gray-400" />
              <input
                type="text"
                placeholder="Rechercher un utilisateur..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="input-field pl-10"
              />
            </div>
          </div>
          <div className="flex gap-4">
            <select
              value={roleFilter}
              onChange={(e) => setRoleFilter(e.target.value)}
              className="input-field"
            >
              <option value="Tous">Tous les rôles</option>
              {roles.map(role => (
                <option key={role.value} value={role.value}>{role.label}</option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Tableau des utilisateurs */}
      <div className="card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-port-gray-200">
            <thead className="bg-port-gray-50">
              <tr>
                <th className="table-header px-6 py-3 text-left">Utilisateur</th>
                <th className="table-header px-6 py-3 text-left">Coordonnées</th>
                <th className="table-header px-6 py-3 text-left">Rôle</th>
                <th className="table-header px-6 py-3 text-left">Statut</th>
                <th className="table-header px-6 py-3 text-left">Dernière connexion</th>
                <th className="table-header px-6 py-3 text-left">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-port-gray-200">
              {filteredUtilisateurs.map((utilisateur) => {
                const roleInfo = getRoleInfo(utilisateur.role);
                return (
                  <tr key={utilisateur.id} className="table-row">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className="h-10 w-10 rounded-full bg-atl-blue-100 flex items-center justify-center">
                          <User className="h-5 w-5 text-atl-blue-600" />
                        </div>
                        <div className="ml-4">
                          <div className="font-medium text-port-gray-900">{utilisateur.nom}</div>
                          <div className="text-sm text-port-gray-500">ID: {utilisateur.id}</div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="space-y-1">
                        <div className="flex items-center text-sm text-port-gray-900">
                          <Mail className="h-4 w-4 mr-2 text-port-gray-400" />
                          {utilisateur.email}
                        </div>
                        <div className="flex items-center text-sm text-port-gray-900">
                          <Phone className="h-4 w-4 mr-2 text-port-gray-400" />
                          {utilisateur.telephone}
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${roleInfo.color}`}>
                        {roleInfo.label}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${
                        utilisateur.statut === 'Actif' ? 'bg-atl-green-100 text-atl-green-800' : 'bg-red-100 text-red-800'
                      }`}>
                        {utilisateur.statut}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="text-sm text-port-gray-900">{utilisateur.derniereConnexion}</span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center space-x-2">
                        <button className="text-atl-blue-600 hover:text-atl-blue-700">
                          <Eye className="h-4 w-4" />
                        </button>
                        {hasPermission('users:write') && (
                          <>
                            <button className="text-port-gray-600 hover:text-port-gray-700">
                              <Edit className="h-4 w-4" />
                            </button>
                            <button className="text-red-600 hover:text-red-700">
                              <Trash2 className="h-4 w-4" />
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Utilisateurs; 